export default __webpack_public_path__ + "static/media/workFlow-BK.c9e04a60.png";